declare global {
  interface Window {
    dataLayer: Record<string, string | string[]>[];
  }
}

type SearchAndFilterEvent = Record<'category' | 'click_text', string | number>;

const handleDataPush = (
  eventname: string,
  values?: { [key: string]: string | number }
) => {
  const { dataLayer } = window;

  if (typeof dataLayer == 'undefined')
    return console.warn('dataLayer is not defined');

  const data = { event: eventname, ...values };

  dataLayer.push(data);
};

export function DLNavClick({
  nav_category,
  nav_level,
  click_text,
}: Record<'nav_category' | 'nav_level' | 'click_text', string | number>) {
  handleDataPush('nav_click', {
    nav_category,
    nav_level,
    click_text,
  });
}

export function DLSearchResultsClick({
  category,
  click_text,
}: SearchAndFilterEvent) {
  handleDataPush('search_results_click', {
    category,
    click_text,
  });
}

export function DLKnowledgehubView({
  knowledgehub_type,
}: Record<'knowledgehub_type', string>) {
  handleDataPush('knowledgehub_view', {
    knowledgehub_type,
  });
}

export function DLFilterClick({ category, click_text }: SearchAndFilterEvent) {
  handleDataPush('filter_click', {
    category,
    click_text,
  });
}

export function DLCtaClick({
  component_title,
  block_name,
  click_text,
}: Record<'component_title' | 'block_name' | 'click_text', string | number>) {
  handleDataPush('cta_click', {
    component_title,
    block_name,
    click_text,
  });
}

export function DLFormStart({
  form_name,
  form_type,
  service_line,
  region,
}: Record<'form_name' | 'form_type' | 'service_line' | 'region', string>) {
  const event = `${form_type || 'generic'}_form_start`;

  handleDataPush(event, {
    form_name,
    form_type,
    service_line,
    region,
  });
}

export function DLFormSubmit({
  form_name,
  form_type,
  service_line,
  region,
}: Record<'form_name' | 'form_type' | 'service_line' | 'region', string>) {
  const event = `${form_type || 'generic'}_form_submit`;

  handleDataPush(event, {
    form_name,
    form_type,
    service_line,
    region,
  });
}

// Handle CTA click event
const ctas = document.querySelectorAll<HTMLElement>('[data-layer-cta-click]');

ctas.forEach(cta => {
  const { layerCtaClick } = cta.dataset,
    data = JSON.parse(layerCtaClick.replace(/(\r\n|\n|\r)/gm, ' '));

  if (!data) return;

  const { title, block, text } = data;

  cta.addEventListener('click', () =>
    DLCtaClick({ component_title: title, block_name: block, click_text: text })
  );
});
